import React from 'react'
import { MenuItemWrapper, RadioButtonStyled, Label } from './RadioButton.styled'

interface RadioButtonProps {
  label: string
  selected: boolean
  $bg?: boolean
  onClick?: () => void
}

export const RadioButton: React.FC<RadioButtonProps> = ({ label, selected, $bg, onClick }) => {
  return (
    <MenuItemWrapper $bg={$bg} onClick={onClick}>
      <Label>{label}</Label>
      <RadioButtonStyled $selected={selected} />
    </MenuItemWrapper>
  )
}
